import { HTTP_STATUS_BAD_REQUEST } from '../../constants/api'
import { CalendarAppointmentStatus } from '../../constants/calendar'
import { EMPTY_OBJECT } from '../../constants/common'
import { sleep } from '../../utils/async'

import {
  APPOINTMENT_MOCK_FOLLOW_UP_RELEASED,
  APPOINTMENT_MOCK_LATENCY,
  AppointmentHistoryAction,
} from './Appointment.constants'
import {
  getAppointmentMockRecord,
  saveAppointmentMockRecord,
  saveAppointmentMockRequestDueDate,
} from './Appointment.mock.store'
import {
  getAppointmentMockError,
  getIsAppointmentMockSameInstant,
  toAppointmentMockHistoryEntry,
} from './Appointment.mock.utils'
import {
  getAppointmentMockDueDateChangedError,
  toAppointmentMockAppliedRecord,
  toAppointmentMockCancelPreview,
  toAppointmentMockClosedRecord,
  toAppointmentMockFollowUpAnswer,
} from './Appointment.mock.utils.followUp'
import { getIsAppointmentFollowUpApply } from './Appointment.utils'

function saveAppointmentMockClosedRecord({ closedRecord, record }) {
  if (
    !getIsAppointmentMockSameInstant(
      closedRecord.requestDueDate,
      record.requestDueDate
    )
  ) {
    saveAppointmentMockRequestDueDate(closedRecord)
  }

  return saveAppointmentMockRecord(closedRecord)
}

export function answerMockAppointmentFollowUp({ data, id }) {
  return sleep(APPOINTMENT_MOCK_LATENCY).then(() => {
    const record = getAppointmentMockRecord(id)

    if (!record.anchor.request) {
      throw getAppointmentMockError({ status: HTTP_STATUS_BAD_REQUEST })
    }

    if (
      !getIsAppointmentMockSameInstant(
        data.expected_current_due_date,
        record.requestDueDate
      )
    ) {
      throw getAppointmentMockDueDateChangedError(record)
    }

    const savedRecord = getIsAppointmentFollowUpApply(data.action)
      ? saveAppointmentMockRequestDueDate(
          saveAppointmentMockRecord(toAppointmentMockAppliedRecord(record))
        )
      : saveAppointmentMockRecord({
          ...record,
          follow_up: APPOINTMENT_MOCK_FOLLOW_UP_RELEASED,
        })

    return { data: toAppointmentMockFollowUpAnswer(savedRecord) }
  })
}

export function cancelMockAppointment({ data = EMPTY_OBJECT, id }) {
  return sleep(APPOINTMENT_MOCK_LATENCY).then(() => {
    const record = getAppointmentMockRecord(id)

    const closedRecord = toAppointmentMockClosedRecord({ data, record })

    saveAppointmentMockClosedRecord({
      closedRecord: {
        ...closedRecord,
        history: [
          toAppointmentMockHistoryEntry({
            action: AppointmentHistoryAction.cancelled,
            actor: record.organizer,
            payload: { start_at: record.start_at, title: record.title },
          }),
          ...closedRecord.history,
        ],
        status: CalendarAppointmentStatus.cancelled,
      },
      record,
    })

    return { data: null }
  })
}

export function deleteMockAppointment({ data = EMPTY_OBJECT, id }) {
  return sleep(APPOINTMENT_MOCK_LATENCY).then(() => {
    const record = getAppointmentMockRecord(id)

    saveAppointmentMockClosedRecord({
      closedRecord: {
        ...toAppointmentMockClosedRecord({ data, record }),
        deletedAt: new Date().toISOString(),
      },
      record,
    })

    return { data: null }
  })
}

export function getMockAppointmentCancelPreview({ id }) {
  return sleep(APPOINTMENT_MOCK_LATENCY).then(() => ({
    data: toAppointmentMockCancelPreview(getAppointmentMockRecord(id)),
  }))
}
